/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for creating a header on a remote MCP server. Exactly one of value or value_from_request_header must be provided.
 */
export type CreateServerHeaderForm = {
  /**
   * Description of the header
   */
  description?: string | undefined;
  /**
   * Whether the header is required. Defaults to false.
   */
  isRequired?: boolean | undefined;
  /**
   * Whether the header value is a secret. Defaults to false. Incompatible with value_from_request_header.
   */
  isSecret?: boolean | undefined;
  /**
   * The header name
   */
  name: string;
  /**
   * The ID of the remote MCP server to add the header to
   */
  remoteMcpServerId: string;
  /**
   * Static header value (mutually exclusive with value_from_request_header)
   */
  value?: string | undefined;
  /**
   * Name of the inbound request header to pass through (mutually exclusive with value)
   */
  valueFromRequestHeader?: string | undefined;
};

/** @internal */
export type CreateServerHeaderForm$Outbound = {
  description?: string | undefined;
  is_required?: boolean | undefined;
  is_secret?: boolean | undefined;
  name: string;
  remote_mcp_server_id: string;
  value?: string | undefined;
  value_from_request_header?: string | undefined;
};

/** @internal */
export const CreateServerHeaderForm$outboundSchema: z.ZodMiniType<
  CreateServerHeaderForm$Outbound,
  CreateServerHeaderForm
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    isRequired: z.optional(z.boolean()),
    isSecret: z.optional(z.boolean()),
    name: z.string(),
    remoteMcpServerId: z.string(),
    value: z.optional(z.string()),
    valueFromRequestHeader: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      isRequired: "is_required",
      isSecret: "is_secret",
      remoteMcpServerId: "remote_mcp_server_id",
      valueFromRequestHeader: "value_from_request_header",
    });
  }),
);

export function createServerHeaderFormToJSON(
  createServerHeaderForm: CreateServerHeaderForm,
): string {
  return JSON.stringify(
    CreateServerHeaderForm$outboundSchema.parse(createServerHeaderForm),
  );
}
